import React from "react";
import CurrentRankReportView from "./CurrentRankReportView";

export default function CurrentBuilderRankReportPage() {
  return <CurrentRankReportView variant="builder" />;
}
